<!--
 * @Author: guoqing 370541946@qq.com
 * @Date: 2025-02-05 18:01:42
 * @FilePath: /insuranceagent-ui/src/components/moreSelect.vue
 * @Description: 使用ID 大数据搜索，选择组件
-->
<template>
	<div>
		<el-select
			v-model="selectValue"
			:loading="isRemoteLoading"
			:remote-method="onRemoteM"
			@clear="onClearSelect"
			filterable
			clearable
			:placeholder="placeholder"
			remote>
			<el-option
				v-for="(itemData, index) in selectDataList"
				:key="index"
				:label="itemData[labelKey]"
				:value="itemData[valueKey]"></el-option>
		</el-select>
	</div>
</template>

<script>
import {getObjListMain} from '@/api/team/place'

// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import { mapGetters } from 'vuex'

export default {
	name: 'moreSelect',
	mixins: [],
	components: {},
	props: {
		selectType: {
			type: String,
			default: '1',
		},
		placeholder: {
			type: String,
			default: '请选择',
		},
		// lable ,value
		labelKey: {
			type: String,
			default: 'name',
		},
		valueKey: {
			type: String,
			default: 'id',
		},
		pageData: {
			type: Object,
			default: () => {
				return {size: 20, pageSize: 20, page: 1}
			},
		},
	},
	data() {
		return {
			selectValue: '',
			isRemoteLoading: false,
			selectDataList: [],
			allDataList: [],
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {},
	methods: {
		// 请求数据
		onRemoteM(query = '') {
			let tempData = this.allDataList
			// 如果query为不为空，则过滤
			if (query) {
				tempData = tempData.filter((item) => {
					// 如果labelKey或者valueKey包含query，则返回
					return item[this.labelKey] && `${item[this.labelKey]}`.includes(query)
				})
			}
			// 如果tempData长度小于等于20，则直接返回，否则切割20个
			this.selectDataList = tempData.length <= 20 ? tempData : tempData.slice(0, 50)
		},
		//获取所有数据
		async onRemoteAllData() {
			try {
				this.isRemoteLoading = true
				let tempRes = ''
				switch (this.selectType) {
					case '1':
						//渠道搜索
						tempRes = (await getObjListMain({parentId: 0, state: 1})) || {}
						break
					case '2':
						//佣金券数据搜索
						tempRes = (await getCouponList({delFlag: '0'})) || {}
						break
					default:
						break
				}
				//用 await 等待请求结果
				let {code = 0, data = [], msg = ''} = tempRes.data || {}
				if (code !== 0) {
					this.$message.error(msg || '请求失败')
					return
				}
				//如果selectType = 2，则还得处理数据，把相同的name合并
				if (this.selectType === '2') {
					let tempData = []
					data.forEach((itemData) => {
						let tempIndex = tempData.findIndex(({name}) => name === itemData.name)
						if (tempIndex === -1) {
							tempData.push(itemData)
						}
					})
					data = tempData
				}
				this.allDataList = data
				//过滤掉this.labelKey为空的数据
				this.allDataList = this.allDataList.filter((item) => item[this.labelKey])
				this.onRemoteM()
				this.isRemoteLoading = false
			} catch (error) {
				this.isRemoteLoading = false
				this.$message.error('请求失败')
			}
		},
		//获取选择的值
		onGetSelectValue() {
			return this.selectValue
		},
		//获取选择的label
		onGetSelectLabel() {
			let tempData = this.selectDataList.find((itemData) => itemData[this.valueKey] === this.selectValue)
			//三元运算符
			return tempData ? tempData[this.labelKey] : ''
		},
		onClearSelect() {
			this.selectValue = ''
			this.onRemoteM()
		},
	},
	created() {},
	// 生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
		this.onRemoteAllData()
	},
	activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
	beforeCreate() {}, // 生命周期 - 创建之前
	beforeMount() {}, // 生命周期 - 挂载之前
	beforeUpdate() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
}
</script>

<style lang="less" scoped></style>
